/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type LoadChatOverviewSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type LoadChatOverviewSecurityOption2 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type LoadChatOverviewSecurityOption3 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type LoadChatOverviewSecurity = {
  option1?: LoadChatOverviewSecurityOption1 | undefined;
  option2?: LoadChatOverviewSecurityOption2 | undefined;
  option3?: LoadChatOverviewSecurityOption3 | undefined;
};

export type LoadChatOverviewRequest = {
  /**
   * The ID of the chat
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type LoadChatOverviewSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const LoadChatOverviewSecurityOption1$outboundSchema: z.ZodMiniType<
  LoadChatOverviewSecurityOption1$Outbound,
  LoadChatOverviewSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function loadChatOverviewSecurityOption1ToJSON(
  loadChatOverviewSecurityOption1: LoadChatOverviewSecurityOption1,
): string {
  return JSON.stringify(
    LoadChatOverviewSecurityOption1$outboundSchema.parse(
      loadChatOverviewSecurityOption1,
    ),
  );
}

/** @internal */
export type LoadChatOverviewSecurityOption2$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const LoadChatOverviewSecurityOption2$outboundSchema: z.ZodMiniType<
  LoadChatOverviewSecurityOption2$Outbound,
  LoadChatOverviewSecurityOption2
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function loadChatOverviewSecurityOption2ToJSON(
  loadChatOverviewSecurityOption2: LoadChatOverviewSecurityOption2,
): string {
  return JSON.stringify(
    LoadChatOverviewSecurityOption2$outboundSchema.parse(
      loadChatOverviewSecurityOption2,
    ),
  );
}

/** @internal */
export type LoadChatOverviewSecurityOption3$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const LoadChatOverviewSecurityOption3$outboundSchema: z.ZodMiniType<
  LoadChatOverviewSecurityOption3$Outbound,
  LoadChatOverviewSecurityOption3
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function loadChatOverviewSecurityOption3ToJSON(
  loadChatOverviewSecurityOption3: LoadChatOverviewSecurityOption3,
): string {
  return JSON.stringify(
    LoadChatOverviewSecurityOption3$outboundSchema.parse(
      loadChatOverviewSecurityOption3,
    ),
  );
}

/** @internal */
export type LoadChatOverviewSecurity$Outbound = {
  Option1?: LoadChatOverviewSecurityOption1$Outbound | undefined;
  Option2?: LoadChatOverviewSecurityOption2$Outbound | undefined;
  Option3?: LoadChatOverviewSecurityOption3$Outbound | undefined;
};

/** @internal */
export const LoadChatOverviewSecurity$outboundSchema: z.ZodMiniType<
  LoadChatOverviewSecurity$Outbound,
  LoadChatOverviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => LoadChatOverviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => LoadChatOverviewSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => LoadChatOverviewSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function loadChatOverviewSecurityToJSON(
  loadChatOverviewSecurity: LoadChatOverviewSecurity,
): string {
  return JSON.stringify(
    LoadChatOverviewSecurity$outboundSchema.parse(loadChatOverviewSecurity),
  );
}

/** @internal */
export type LoadChatOverviewRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const LoadChatOverviewRequest$outboundSchema: z.ZodMiniType<
  LoadChatOverviewRequest$Outbound,
  LoadChatOverviewRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function loadChatOverviewRequestToJSON(
  loadChatOverviewRequest: LoadChatOverviewRequest,
): string {
  return JSON.stringify(
    LoadChatOverviewRequest$outboundSchema.parse(loadChatOverviewRequest),
  );
}
